import { AuthGuard } from "@redotech/redo-customer-portal-app/contexts/auth";
import { Outlet, RouteObject } from "react-router-dom";
import { Page } from "../order/page";

export const retailRoutes: RouteObject[] = [
  {
    element: (
      <AuthGuard>
        <Page>
          <Outlet />
        </Page>
      </AuthGuard>
    ),
    children: [
      {
        index: true,
        lazy: async () => {
          const { RetailActions } =
            await import("@redotech/redo-customer-portal-app/portal-four/register/retail-actions");
          return { element: <RetailActions /> };
        },
      },
      {
        path: "register",
        lazy: async () => {
          const { Main: RegistrationPortal } =
            await import("@redotech/redo-customer-portal-app/portal-four/register/main");
          return { element: <RegistrationPortal /> };
        },
      },
      {
        path: ":returnType",
        lazy: async () => {
          const { RetailReturnTypeMain } =
            await import("@redotech/redo-customer-portal-app/portal-four/register/retail-return-type-main");
          return { element: <RetailReturnTypeMain /> };
        },
      },
      {
        path: "registrations",
        children: [
          {
            path: ":id",
            lazy: async () => {
              const { RegisteredWarrantyDetails } =
                await import("../warranties/registered-warranty-details");
              return { element: <RegisteredWarrantyDetails /> };
            },
          },
        ],
      },
    ],
  },
];
